<template>
  <v-card
    outlined
    class="fill-height"
  >
    <v-card-text>
      <SectionTitle :title="$t('views.production-foreman.materialList')" />
      <v-data-table
        :headers="headers"
        :items="items"
        style="overflow: auto"
        height="100%"
        dense
        fixed-header
        single-select
        disable-pagination
        hide-default-footer
        class="row-pointer mt-2"
      >
        <template #headerCell="{ header }">
          <span
            class="subheading font-weight-light text-success text--darken-3"
            v-text="header.text"
          />
        </template>
        <template #item="{ item }">
          <tr
            :class="{ 'grey lighten-2': item.id === selectedFormula }"
            @click="onItemSelected(item)"
          >
            <td class="font-weight-semibold text-start">
              {{ item.formula }}
            </td>
            <td>{{ formatSpec(item) }}</td>
            <td>{{ item.labSampleCount }}</td>
            <td>{{ item.jobsiteCount }}</td>
            <td>{{ formatDate(item.lastResultDate) }}</td>
            <td class="text-end">
              <TrendChip
                v-if="item.IQBeton"
                :risk="computeRisk(item.IQBeton)"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import SectionTitle from '@/components/core/SectionTitle.vue'
import TrendChip from '@/components/DashViews/Charts/TrendChip.vue'
import { computeRiskFromWeight } from '@/utils/kpi'

export default {
  name: 'ConcreteForemanList',
  components: {
    SectionTitle,
    TrendChip,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    selectedFormula: {
      type: String,
      required: true,
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('views.production-foreman.concreteTable.formula'),
          sortable: false,
          align: 'start',
        },
        {
          text: this.$t('views.production-foreman.concreteTable.spec'),
          sortable: false,
        },
        {
          text: this.$t('views.production-foreman.concreteTable.labSamples'),
          sortable: false,
        },
        {
          text: this.$t('views.production-foreman.concreteTable.jobsite'),
          sortable: false,
        },
        {
          text: this.$t('views.production-foreman.concreteTable.lastResult'),
          sortable: false,
        },
        {
          text: this.$t('views.production-foreman.concreteTable.quality'),
          sortable: false,
          align: 'end',
        },
      ]
    },
  },
  methods: {
    onItemSelected(value) {
      if (value.id !== this.selectedFormula) {
        this.$emit('onItemSelected', value)
      }
    },
    formatSpec(item) {
      const no = item.specNo
      const desc = item.specDescription
      if (no && desc) return `${no} – ${desc}`
      return no || desc || '—'
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString() : '—'
    },
    computeRisk: computeRiskFromWeight,
  },
}
</script>

<style scoped lang="scss">
@import '@/styles/material-dashboard/variables.scss';
</style>
